import React, { useState, useRef } from "react";

const UploadInvoicesBox = ({ onFileUpload }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const dropRef = useRef(null);
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragging(true);
    }
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const event = { target: { files: e.dataTransfer.files } };
      onFileUpload(event);
      e.dataTransfer.clearData();
    }
  };

  const handleFileSelect = (event) => {
    onFileUpload(event);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <div className="upload-container">
      <style>
        {`
          .upload-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2rem;
          }

          .upload-box {
            width: 100%;
            max-width: 600px;
            background: white;
            border-radius: 16px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
            padding: 2.5rem;
            text-align: center;
          }

          .upload-icon {
            width: 120px;
            height: 120px;
            background-color: #f0f9ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 1.5rem;
            transition: all 0.3s ease;
          }

          .upload-icon:hover {
            transform: scale(1.05);
            background-color: #e6f2ff;
            box-shadow: 0 10px 25px rgba(59, 130, 246, 0.2);
          }

          .upload-icon svg {
            transition: all 0.3s ease;
          }

          .upload-icon:hover svg {
            transform: translateY(-5px);
          }

          .upload-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #1F2937;
            margin-bottom: 0.75rem;
          }

          .upload-description {
            color: #6B7280;
            margin-bottom: 1.5rem;
          }

          .drop-zone {
            border: 2px dashed #D1D5DB;
            border-radius: 12px;
            padding: 2.5rem;
            cursor: pointer;
            transition: all 0.3s ease;
            background-color: #ffffff;
            margin-bottom: 1.5rem;
          }

          .drop-zone.dragging {
            border-color: #3B82F6;
            background-color: #f3f4f6;
          }

          .drop-zone:hover {
            border-color: #3B82F6;
            background-color: #f3f4f6;
          }

          .drop-text {
            color: #4B5563;
            font-weight: 500;
          }

          .upload-button {
            padding: 0.75rem 1.5rem;
            background-color: #3B82F6;
            color: white;
            border: none;
            border-radius: 8px;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }

          .upload-button:hover {
            background-color: #2563EB;
            transform: translateY(-1px);
            box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
          }

          .file-input {
            display: none;
          }
        `}
      </style>

      <div className="upload-box">
        <div className="upload-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#3B82F6"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
        </div>

        <h2 className="upload-title">Upload Purchase Orders</h2>
        
        <p className="upload-description">
          Drag and drop your files or click to select. Supports PDF files up to 10MB.
        </p>

        <div
          ref={dropRef}
          className={`drop-zone ${isDragging ? 'dragging' : ''}`}
          onClick={handleClick}
          onDragEnter={handleDragIn}
          onDragLeave={handleDragOut}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <p className="drop-text">
            {isDragging ? 'Drop files here' : 'Click to Select or Drag Files Here'}
          </p>
        </div>

        <button className="upload-button" onClick={handleClick}>
          Select Purchase Order
        </button>

        <input
          ref={inputRef}
          type="file"
          className="file-input"
          multiple
          accept=".pdf"
          onChange={handleFileSelect}
        />
      </div>
    </div>
  );
};

export default UploadInvoicesBox;
